import React, { useCallback, useEffect, useState } from 'react';
import { MetricTypeEnum } from 'enums/MetricTypeEnum';
import { getMeasurementsByDay, getMetricValuesByRange } from 'services/metrics';
import { usePatient } from 'hooks/patient';
import { Data, evolutionFormat } from 'utils/getEvolutionFormat';
import { toast } from 'react-toastify';
import { Container, Dates, Item, Values } from './styles';
import { DateRangeType } from '../Modals/EvolutionModal';
import Default, {
  ShowScreenType,
} from '../Modals/EvolutionModal/Charts/_Default';

interface EvolutionTableProps {
  metric: MetricTypeEnum;
  dateRange: DateRangeType;
}

export default function EvolutionTable({
  metric,
  dateRange,
}: EvolutionTableProps) {
  const { patient } = usePatient();
  const [tables, setTables] = useState<Data>();
  const [showScreen, setShowScreen] = useState<ShowScreenType>('chart');

  const GetEvolutionTableData = useCallback(async () => {
    if (!patient?.id) return;
    const { endDate, startDate } = dateRange;
    const isDateEqually = startDate.getTime() === endDate.getTime();

    setShowScreen('loading');

    let data;
    try {
      if (isDateEqually) {
        data = await getMeasurementsByDay({
          dateFilter: startDate,
          metricType: metric,
          patientId: patient.id,
        });
      } else {
        data = await getMetricValuesByRange({
          endDate,
          startDate,
          metricType: metric,
          patientId: patient?.id,
        });
      }

      const formattedDays = evolutionFormat(data);

      if (formattedDays.dates.length > 0) {
        setTables(formattedDays);
        setShowScreen('chart');
      } else {
        setShowScreen('noData');
      }
    } catch (error) {
      setShowScreen('noData');
      toast.error(
        'Aconteceu um problema, Entre em contato com o administrador.',
      );
      console.log(error);
    }
  }, [dateRange, metric, patient]);

  useEffect(() => {
    GetEvolutionTableData();
  }, [GetEvolutionTableData]);

  return (
    <Default showScreen={showScreen}>
      <Container>
        <Values>
          <Item type="hour">
            {/* Coluna feita para fazer espaço, visibility 0 */}
            <div>Hour </div>

            {tables?.hours?.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </Item>

          <Dates>
            {tables?.dates?.map((item) => (
              <Item key={item.date} type="date">
                <span>{item.date}</span>
                {item.values?.map((values) => (
                  <div>
                    <strong>{values.value}</strong>
                  </div>
                ))}
              </Item>
            ))}
          </Dates>
        </Values>
      </Container>
    </Default>
  );
}
